/*=========================================================================================
  File Name: sidebarUiUx.js
  Description: Vuex Store - sidebar UI UX
==========================================================================================*/

import axios from 'axios';
import state from '../state';

export default {
    updateSidebarWidth({commit}, width) {
        commit('UPDATE_SIDEBAR_WIDTH', width);
    },
    updateWindowWidth({commit}, width) {
        commit('UPDATE_WINDOW_WIDTH', width);
    },
    toggleContentOverlay({commit}) {
        commit('TOGGLE_CONTENT_OVERLAY');
    },
    updateTheme({commit}, payload) {
        return new Promise((resolve) => {
            commit('UPDATE_THEME', payload);
            axios.post(state.API_URL + '/auth/theme-settings/update', payload).then(({data}) => {
                payload.notify({
                    time: 3500,
                    text: state.currentTranslations[data.message],
                    iconPack: 'feather',
                    icon: 'icon-check',
                    color: 'success'
                });

                resolve();
            });
        });
    },
};
